import type { Release } from '../releases.ts';

export default {
  version: '0.12.0',
  date: '2026-10-02',
  title: 'Flows and integration',
  summary: [
    'Delete workflows; past runs stay visible',
    'Webhooks in Administration, with a test call and the last outcome',
    'New workflow steps: Delay, Repeat until and Map metadata',
    'Help guides to workflows and sidecars, and an API reference with Try it',
    'Watch folders read JSON sidecars as well as XML',
  ],
  features: [
    'Delete workflows (runs under way finish; past runs stay visible)',
    'The Export sequence step chooses where the export goes',
    'Administration → Webhooks: endpoints with POST, PUT or GET, encrypted extra headers, a test call, a new signing secret and the last call’s outcome',
    'Webhook triggers also accept GET with query parameters',
    'Call webhook steps add a path to the endpoint’s URL and pass the JSON answer to later steps',
    'New steps: Delay; Repeat until (check the asset or an endpoint every so often until conditions hold); Map metadata (from the trigger, earlier steps or a webhook’s answer, with transforms, lookups and fill-only-empty)',
    'Every step lists the variables it can use in templates',
    'Help: guides to workflows (steps, variables, webhooks, loops) and to sidecar metadata, and an API reference with Try it',
    'Watch folders read JSON sidecars as well as XML, and choose whether sidecars or the folder’s defaults win',
  ],
  fixes: [],
} satisfies Release;
